import { render, staticRenderFns } from "./linklist.vue?vue&type=template&id=766364db&scoped=true&"
import script from "./linklist.vue?vue&type=script&lang=js&"
export * from "./linklist.vue?vue&type=script&lang=js&"
import style0 from "./linklist.vue?vue&type=style&index=0&id=766364db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766364db",
  null
  
)

export default component.exports